<template>
    <v-card :loading="loading" mx-4 min-height="500">
        <template slot="progress">
            <v-overlay absolute class="d-flex flex-column text-center">
                <div>
                    <v-progress-circular size="250" width="10" color="primary" indeterminate>
                        <span>In curs de incarcare...</span>
                    </v-progress-circular>
                </div>
            </v-overlay>
        </template>
        <v-card-title>
            {{ title }}
            <v-spacer></v-spacer>
            <v-checkbox
                class="pt-5 mr-5"
                v-model="showCurrent"
                label="Afisare informatiile actuale"
            />
            <search-field v-model="search"></search-field>
            <v-dialog
                v-model="dialog"
                max-width="500px"
            >
                <v-card>
                    <v-card-title>
                        <span class="headline">{{ formTitle }}</span>
                    </v-card-title>

                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-col cols="12" sm="12">
                                    <v-text-field
                                        :value="_.get(form, 'vehicle.vehicle_plate')"
                                        disabled
                                        label="Vehicul"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12">
                                    <v-text-field
                                        :value="_.get(form, 'customer.name')"
                                        disabled
                                        label="Client"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12">
                                    <v-date-field
                                        v-model="form.next_inspection"
                                        label="Data expirarii"
                                        inputmask-placeholder="99-99-9999"
                                        placeholder="zz-ll-aaaa"
                                    ></v-date-field>
                                </v-col>
                                <v-col cols="12" sm="12">
                                    <v-checkbox
                                        v-model="form.allow_notification"
                                        label="Permite notificari"
                                    ></v-checkbox>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="blue darken-1"
                            text
                            @click="close"
                        >
                            Renuntare
                        </v-btn>
                        <v-btn
                            color="blue darken-1"
                            text
                            @click="save"
                        >
                            Salveaza
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-card-title>
        <v-data-table
            :headers="headers"
            :items="items"
            :options.sync="options"
            :server-items-length="meta.pagination.total"
            class="elevation-1"
        >
            <template v-slot:item.customer_id="{ item }">
                {{ _.get(item, 'vehicle.customer.name') }}
            </template>
            <template v-slot:item.contact_phone="{ item }">
                {{ _.get(item, 'vehicle.customer.contact_phone') }}
            </template>
            <template v-slot:item.vehicle_id="{ item }">
                {{ _.get(item, 'vehicle.vehicle_plate', '-') }} - {{ _.get(item, 'vehicle.brand', '-') }} {{ _.get(item, 'vehicle.model', '-') }}
            </template>
            <template v-slot:item.next_inspection="{ item }">
                {{ new Date(item.next_inspection) | date }}
            </template>
            <template v-slot:item.allow_notification="{ item }">
                <v-chip :color="item.allow_notification ? 'success' : 'error'">
                    {{ item.allow_notification ? 'Da' : 'Nu' }}
                </v-chip>
            </template>
            <template v-slot:item.updated_at="{ item }">
                {{ new Date(item.updated_at) | datetime }}
            </template>
            <template v-slot:item.actions="{ item }">
                <v-icon
                    v-if="canUpdate(item)"
                    small
                    class="mr-2"
                    @click="editItem(item)"
                >
                    mdi-pencil
                </v-icon>
            </template>
            <template v-slot:no-data>
                <p class="my-2">Nu am gasit nici un rezultat.</p>
                <v-btn
                    class="my-2"
                    color="primary"
                    @click="reset"
                >
                    Eliminare filtre
                </v-btn>
            </template>
        </v-data-table>
    </v-card>
</template>

<script>
    import SmartTable from "Components/SmartTable";
    import {Form} from "vform";
    export default {
        extends: SmartTable,
        data: () => ({
            title: 'Inspectii tehnice',
            dialog: false,
            dialogDelete: false,
            showCurrent: true,
            headers: [
                { text: 'Vehicul', value: 'vehicle_id' },
                { text: 'Client', value: 'customer_id', sortable: false },
                { text: 'Telefon contact', value: 'contact_phone', sortable: false },
                { text: 'Expirare', value: 'next_inspection' },
                { text: 'Sursa expirarii', value: 'reference' },
                { text: 'Permite notificari', value: 'allow_notification' },
                { text: 'Data actualizarii', value: 'updated_at' },
                { text: 'Actiuni', value: 'actions', sortable: false },
            ],
            items: [],
            editedIndex: -1,
            options: {
                sortBy: ['id'],
                sortDesc: [true]
            },
        }),

        computed: {
            formTitle () {
                return this.editedIndex === -1 ? 'Adaugare' : 'Modificare'
            },
        },

        watch: {
            dialog (val) {
                val || this.close()
            },
            showCurrent: {
                handler (val) {
                    this.initialize()
                }
            }
        },

        async created () {
            await this.initialize()
        },

        methods: {
            async initialize () {
                this.loading = true
                var query = this.$db.InspectionIndex
                    .include('vehicle.customer')
                    .orderBy(this.orderBy)
                    .page(this.options.page)
                    .limit(this.options.itemsPerPage)
                    .params({
                        query: this.search
                    })
                if(this.showCurrent) query = query.where('showCurrent', true)
                let { data, meta } = await query.get()
                this.items = data
                this.meta = meta
                this.loading = false
            },

            editItem (item) {
                let next_inspection = null
                this.editedIndex = this.items.indexOf(item)
                if (!this._.isNil(item.next_inspection)) {
                    next_inspection = this.$moment(item.next_inspection, 'YYYY-MM-DD').format('DD-MM-YYYY')
                }
                this.form = new Form(Object.assign({}, item, {customer: item.vehicle.customer, next_inspection}))
                this.dialog = true
            },
            async save () {
                if (this.editedIndex > -1) {
                    await this.updateDatabase()
                } else {
                    this.showError("Adaugarea nu este permisa!");
                }
            },
            async updateDatabase() {
                let self = this;
                self.form.busy = true;

                var model = new this.$db.InspectionIndex(Object.assign(self.form, {
                    next_inspection: this.$moment(self.form.next_inspection, 'DD-MM-YYYY').format('YYYY-MM-DD')
                }));
                if (this.id) {
                    model.id = this.id
                }

                return model.save()
                    .then(response => {
                        self.$validator.reset();
                        self.form.errors.set({})
                        self.showSuccess();
                        self.close()
                    })
                    .catch(errors => {
                        self.form.errors.set(this.form.extractErrors(errors.response))
                        self.showError()
                    }).finally(async () => {
                        await self.initialize()
                        self.form.busy = false;
                    });
            }
        },
    };
</script>
